import { findVariantPatchConflicts } from "./findVariantPatchConflicts";
import { VariantInformation } from "./isVariantInformation";

/**
 * Groups the full patch catalogue by direct or transitive property overlap.
 *
 * @param information - Persisted named patches and variant templates
 * @returns Connected groups in catalogue order, including independent patches
 */
export const groupVariantPatches = (information: VariantInformation): string[][] => {
  const patchNames = Object.keys(information.allVariantPatches);
  const groups = patchNames.map((name) => [name]);
  findVariantPatchConflicts(information, patchNames).forEach((conflict) => {
    const firstIndex = groups.findIndex((group) => group.includes(conflict.firstPatchName));
    const secondIndex = groups.findIndex((group) => group.includes(conflict.secondPatchName));
    if (firstIndex !== secondIndex) {
      const retainedIndex = Math.min(firstIndex, secondIndex);
      const removedIndex = Math.max(firstIndex, secondIndex);
      groups[retainedIndex].push(...groups[removedIndex]);
      groups.splice(removedIndex, 1);
    }
  });
  return groups.map((group) => patchNames.filter((name) => group.includes(name)));
};
